/**
 * Feature: Financeiro
 * Módulos: Gestão de reembolsos (LCMY_GO_EXPENSES)
 */

export { default as GestaoReembolsosPage } from './components/GestaoReembolsosPage';

export const FINANCEIRO_REEMBOLSOS_ROUTE = '/financeiro/reembolsos';
export const FINANCEIRO_ROUTES = [FINANCEIRO_REEMBOLSOS_ROUTE];
